<template>
  <div class="generator">
    <button class="button" v-on:click="changeName" type="button">{{ name }}</button>
  </div>
</template>

<script>
import arrayWords from "an-array-of-french-words"
let arrayHostingName = ["hosting","hoster","host", "heberg", "cloud"];

function getHosterName(){
  let suffix = arrayHostingName[Math.floor(Math.random() * arrayHostingName.length)];
  let word = arrayWords[Math.floor(Math.random() * arrayWords.length)];
  return word +"-"+suffix;
}

export default {
  name: "Generator",
  data: function () {
    return {
      name: "Click me",
    }
  },
  methods: {
    changeName: function () {
      let newName = getHosterName();
      this.name = newName;
    }
  }
}
</script>

<style>
.button {
  width: 50%;
  height: 5em;
  border: none;
  background-color: #BBDEFB;
  color: #212121;
  font-size: 3em;
  cursor: pointer;
  text-align: center;
  border-radius: 10%;
}
</style>